export const CONTACT_EMAIL = "contact@techmaker.com";
export const ROTATION_INTERVAL_MS = 20_000;
export const MORPH_DURATION_MS = 900;

export type Locale = "en" | "de";
